import type { ToolCallMessagePartComponent } from '@assistant-ui/react';
import { CheckIcon, LoaderIcon } from 'lucide-react';

const toolLabels: Record<string, string> = {
	businessMetricsTool: 'Fetching business metrics',
	commercialBillingDetailTool: 'Reviewing billing details',
	commercialBillingOverviewTool: 'Reviewing billing overview',
	csvExportTool: 'Generating CSV export',
	customerTool: 'Searching customers',
	estimatesTool: 'Checking estimates',
	floorPlanSummaryTool: 'Checking floor plan progress',
	invoiceStatusTool: 'Checking invoices',
	jobSearchTool: 'Searching jobs',
	jobTool: 'Looking up job details',
	purchaseOrderSearchTool: 'Searching purchase orders',
	purchaseOrdersTool: 'Checking purchase orders',
	quickbooksApiLogTool: 'Checking QuickBooks API activity',
	quickbooksSyncStatusTool: 'Checking QuickBooks sync status',
	scheduleTool: 'Checking schedule',
	submittalSearchTool: 'Searching submittals',
	technicianStatusTool: 'Checking technician status',
};

export const ToolStatus: ToolCallMessagePartComponent = ({ toolName, status }) => {
	const label = toolLabels[toolName] ?? toolName;
	const isRunning = status?.type === 'running';

	return (
		<div className="my-2">
			<span className="inline-flex items-center gap-1.5 rounded-full border bg-muted/50 px-3 py-1 text-muted-foreground text-xs">
				{isRunning ? <LoaderIcon className="size-3 animate-spin" /> : <CheckIcon className="size-3 text-green-600" />}
				{label}
			</span>
		</div>
	);
};
